import { mdiClose, mdiArrowCollapse } from '@mdi/js';
import Icon from '@mdi/react';
import { Chip, DialogTitle, IconButton, Stack, SxProps } from '@mui/material';
import React from 'react';
import { headingFontBold, vars } from '../../../../Theme';

const getChipSx = (color: string) => {
    return {
        ...headingFontBold,
        ml: '8px',
        height: '27px',
        backgroundColor: color,
        color: vars.white,
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineLeight: 'normal',
    };
};

const dialogTitleSx: SxProps = {
    ...headingFontBold,
    p: 0,
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineLeight: 'normal',
};

const variantIcons = {
    close: mdiClose,
    minimize: mdiArrowCollapse,
};

export default ({
    onClose,
    dialogTitle,
    chipColor,
    chipLabel,
    variant = 'close',
}: IDialogHeaderProps) => {
    return (
        <Stack
            direction='row'
            sx={{
                alignItems: 'center',
                p: 3,
                pb: '16px',
            }}
        >
            <DialogTitle sx={dialogTitleSx}>{dialogTitle}</DialogTitle>
            {chipLabel && <Chip label={chipLabel} sx={getChipSx(chipColor)} />}
            <IconButton onClick={onClose} sx={{ marginLeft: 'auto', p: 0 }}>
                <Icon path={variantIcons[variant]} size={1} />
            </IconButton>
        </Stack>
    );
};

export interface IDialogHeaderProps {
    onClose: () => void;
    dialogTitle: string;
    chipColor?: string;
    chipLabel?: string;
    variant?: 'close' | 'minimize';
}
